// @flow
import * as React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import TextField from 'material-ui/TextField';
import DatePicker from 'common/components/DatePicker';
import InputMask from 'react-input-mask';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

type State = {
  value: string;
  showPicker: boolean;
};

type Props = {
  date: moment;
  onDateChanged: (date: moment) => void;
  minDate?: moment;
};

class DatePickerWithInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      value: this.formatDate(props.date),
      showPicker: false,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (!nextProps.date.isSame(this.props.date, 'day')) {
      this.setState({ value: this.formatDate(nextProps.date) });
    }
  }

  formatDate(date: moment): string {
    return date.format('YYYYMMDD');
  }

  parseValue(value: string): string {
    return value.replace(/:|-/g, '');
  }

  parseDate(value: string): moment {
    const parsedValue = this.parseValue(value);
    const year = this.parseYear(parsedValue);
    const month = this.parseMonth(parsedValue);
    const day = this.parseDay(parsedValue);

    let date = moment(`${year}-${month}`, 'YYYY-MM');
    const daysInMonth = date.daysInMonth();

    if (day <= daysInMonth) {
      date.add(day - 1, 'day');
    } else {
      date.add(daysInMonth - 1, 'day');
    }

    if (this.props.minDate && date.isBefore(this.props.minDate)) {
      date = this.props.minDate;
    }

    return date;
  }

  parseYear(value: string): number {
    return Number(value.slice(0, 4).replace(/_/g, '0'));
  }

  parseMonth(value: string): number {
    let months = Number(value.slice(4, 6).replace(/_/g, '0'));

    if (months < 1) {
      months = 1;
    }

    if (months > 12) {
      months = 12;
    }

    return months;
  }

  parseDay(value: string): number {
    let days = Number(value.slice(6, 8).replace(/_/g, '0'));

    if (days < 1) {
      days = 1;
    }

    if (days > 31) {
      days = 31;
    }

    return days;
  }

  onInputChange = (event: any): void => {
    const value: string = event.target.value;
    this.setState({ value });
  }

  onDatePick = (date: moment): void => {
    this.props.onDateChanged(date);
    this.setState({ value: this.formatDate(date) });
  }

  onBlur = (): void => {
    const { value } = this.state;
    const date = this.parseDate(value);

    this.props.onDateChanged(date);
    this.setState({ value: this.formatDate(date) });
  }

  onCalendarClick = (): void => {
    this.setState({ showPicker: true });
  }

  render() {
    const date = this.parseDate(this.state.value);

    return (
      <Wrapper>
        <DatePicker
          style={{ 'textAlign': 'center' }}
          showIcon
          weekOnly
          date={date}
          onDateChange={this.onDatePick}
          minDate={this.props.minDate}
        />
        <TextField fullWidth onBlur={this.onBlur} id="date-picker">
          <InputMask value={this.state.value} mask="9999-99-99" onChange={this.onInputChange} />
        </TextField>
      </Wrapper>
    );
  }
}

export default DatePickerWithInput;



// WEBPACK FOOTER //
// ./src/statsradio/components/DatePickerWithInput.js